<template>
  <v-card outlined class="mb-5 pl-2" color="grey lighten-4">
    <v-card-text class="pt-2 pb-0">
      <span class="body-2"
        ><v-icon class="mr-1 mb-1" small>fas fa-edit</v-icon> BATCH EDIT:
        <span v-if="releaseNoteSearchIsLoading"
          ><v-icon class="spinner mx-3" size="15">fa fa-spinner</v-icon></span
        ></span
      >
      <v-row justify-end>
        <v-col sm="12" md="2">
          <template v-if="!hasTestPlanEdit || !selectedItems.length">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete
                  v-bind="attrs"
                  v-on="on"
                  :disabled="batchEditIsDisabled"
                  :items="testingStatusList"
                  @change="testingStatusDialog = true"
                  class="my-2"
                  data-cy="batchEdit-testingStatus-dropdown"
                  dense
                  hide-details
                  label="Testing Status"
                  outlined
                  single-line
                  v-model="testingStatusSelected"
                />
              </template>
              <span v-if="!hasTestPlanEdit">You do not have permission to edit test plans</span>
              <span v-else>Select one or more items to batch edit</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-autocomplete
              :disabled="batchEditIsDisabled"
              :items="testingStatusList"
              @change="testingStatusDialog = true"
              class="my-2"
              data-cy="batchEdit-testingStatus-dropdown"
              dense
              hide-details
              label="Testing Status"
              outlined
              single-line
              v-model="testingStatusSelected"
            />
          </template>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog v-model="testingStatusDialog" max-width="800" scrollable persistent>
      <batch-edit-confirmation
        :selected-items="selectedItems"
        :selected-value="testingStatusSelected"
        @cancelBatchEdit="cancelBatchEdit('testingStatusSelected')"
        @setDialog="setTestingStatusDialog"
        @submitBatchEdit="submitBatchEdit('status', 'testingStatusSelected')"
        edited-field="status"
        selected-field-display-text="testing status"
      ></batch-edit-confirmation>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import dropdownValues from "@/store/staticDropdowns";
import BatchEditConfirmation from "./BatchEditConfirmation";

export default {
  components: { BatchEditConfirmation },
  computed: {
    // permission flag
    ...mapGetters({ hasTestPlanEdit: "session/hasTestPlanEdit", featureFlagMap: "featureFlag/getFlagMap" }),
    ...mapState({
      userServiceAreaId: state => state.session.user.serviceArea,
      releaseNoteSearchIsLoading: state => state.releaseNote.isLoadingReleaseNoteSearch,
    }),
    batchEditIsDisabled() {
      return !this.selectedItems.length || this.releaseNoteSearchIsLoading || !this.hasTestPlanEdit;
    },
    historicallyNotImpactedFeatureFlag() {
      return this.featureFlagMap.historicallyNotImpacted;
    },
    testingStatusList() {
      if (this.historicallyNotImpactedFeatureFlag) {
        // TODO: The line below should be the only return statement after the feature flag is removed
        return this.dropdownValues.testingStatus.filter(item => item.batchEditable === true).map(item => item.value);
      } else {
        return this.dropdownValues.testingStatus
          .filter(item => item.batchEditable === true && item.value !== "Historically Not Impacted")
          .map(item => item.value);
      }
    },
  },
  data() {
    return {
      dropdownValues,
      testingStatusDialog: false,
      testingStatusSelected: null,
    };
  },
  methods: {
    async cancelBatchEdit(value) {
      this[`${value}`] = null;
    },
    async submitBatchEdit(field, value) {
      const batchEditValue = this[`${value}`];

      const serviceAreaId = this.userServiceAreaId;

      const data = this.selectedItems.map(item => {
        return {
          releaseNoteId: item.releaseNoteId,
          [field]: batchEditValue,
        };
      });

      try {
        await this.batchEdit({ serviceAreaId, data });
        this.$notifySuccess(`Successfully edited ${this.selectedItems.length} records`);
        this.selected;
      } catch (e) {
        console.error(e);
        return this.$notifyError("Error submitting batch edit");
      }

      this.updateTestPlanBatchEditSelectionList([]);
      this.$emit("refreshList");
      this[`${value}`] = null;
    },
    setTestingStatusDialog(val) {
      this.testingStatusDialog = val;
    },
    ...mapActions({
      batchEdit: "releaseNote/batchEditTestPlan",
    }),
    ...mapMutations({
      updateTestPlanBatchEditSelectionList: "releaseNote/setTestPlanBatchEditSelectionList",
    }),
  },
  props: {
    selectedItems: {
      type: Array,
      default: [],
    },
  },
};
</script>
